import { render } from "./AlumniBanner.vue?vue&type=template&id=b617fdc8&scoped=true"
import script from "./AlumniBanner.vue?vue&type=script&lang=js"
export * from "./AlumniBanner.vue?vue&type=script&lang=js"

import "./AlumniBanner.vue?vue&type=style&index=0&id=b617fdc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b617fdc8"]])

export default __exports__